export default __webpack_public_path__ + "static/media/Orange.3d8a3aca.svg";